import { forwardRef } from 'react'
import classNames from 'classnames'
import type { CommonProps } from '../@types/common'
import type {
    TextareaHTMLAttributes,
} from 'react'

export interface TextAreaProps
    extends CommonProps,
        TextareaHTMLAttributes<HTMLTextAreaElement> {
    invalid?: boolean
    unstyle?: boolean
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (props, ref) => {
        const {
            className,
            disabled,
            invalid,
            style,
            unstyle = false,
            ...rest
        } = props

        const textAreaClass = classNames(
            !unstyle && 'input',
            !unstyle && 'input-textarea',
            !unstyle && invalid && 'input-invalid',
            className,
            disabled && 'input-disabled'
        )

        return (
            <textarea
                ref={ref}
                className={textAreaClass}
                style={style}
                disabled={disabled}
                {...rest}
            ></textarea>
        )
    }
)

TextArea.displayName = 'TextArea'

export default TextArea 